<template>
  <div class="box">
    <h3>承诺书</h3>
    <div class="text-box">
      <h1 class="">承诺书</h1>
      <div style="text-align: left; color: #000">
        作为项目申报人,我郑重承诺<br />
        1. 承诺人提交的所有材料均符合国家方针和教育政策 ,
        以培养社会主义建设者和接班人为目标,服务立德树人根本任务<br />
        2. 承诺人同意并确认 , 在申报中出现的语言 , 文字和录像资料 ,
        主办方享有出版权和文本影像使用权<br />
        3.
        承诺人在申报中提交的所有材料,不侵犯他人知识产权,由于侵犯知识产权引起的任何法律责任,由承诺人自行承担
        。
      </div>
    </div>
    <div class="pos flex flex-center">
      <div class="submit-btn" @click="agreeBtn">同 意</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    type: Number,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
  },
  methods: {
    agreeBtn() {
      window.localStorage.setItem("isAgree", "true");
      let applyType = this.type;
      let routerName = "";
      if (applyType === 1) {
        routerName = "szStudio";
      } else if (applyType === 2) {
       routerName = "educationalBrand";
      } else {
         routerName = "szMicroClass";
      }
      this.$router.push({
        name: `${routerName}DataUpload`,
        params: { applyType },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  position: relative;
  padding: 15px 29px;
  font-size: 20px;
  font-family: cursive;
  width: 100%;
  height: 100%;
  letter-spacing: 2px;
  background: #fff;
}
.text-box {
  margin: 20px;
  padding: 10px 55px;
  text-align: center;
}
.pos {
  position: absolute;
  bottom: 24px;
  left: 0;
  right: 0;
}
.submit-btn {
  width: 116px;
  height: 40px;
  line-height: 38px;
  text-align: center;
  background: #2155B5;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
